import React from 'react';
import { Button } from 'antd';
import styles from './index.module.scss';

interface IProps {
  onContinueMeeting: () => void;
  onEndMeeting: () => void;
  showContinueMeeting: boolean;
}

const ContinueTip: React.FC<IProps> = ({ onContinueMeeting, onEndMeeting, showContinueMeeting }) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.tip}>
        提示：检测到您预约的会议室无人使用，系统将自动提前结束会议。
        {showContinueMeeting && '如需继续使用，请点击「继续会议」'}
      </div>
      <div className={styles.dangerTip}>如无任何操作，5分钟后系统将自动结束会议。</div>
      <div>
        <Button onClick={onEndMeeting}>提前结束会议</Button>
        {showContinueMeeting && (
          <Button className={styles.continueBtn} onClick={onContinueMeeting}>
            继续会议
          </Button>
        )}
      </div>
    </div>
  );
};

export default ContinueTip;
